<template>
  <div>
    <!-- 购买信息维护 -->
    <div class="item-body">
      <!--购买渠道 -->
      <div class="name">
        {{ $t('message.purchasingChannels') }}
      </div>

      <div class="row">
        <el-radio v-model="detail.client_product_buy_channel.buy_channel" :label="1"> {{ $t('message.onLine')
        }}</el-radio>
      </div>
      <div class="row">
        <el-radio v-model="detail.client_product_buy_channel.buy_channel" :label="2"> {{
          $t('message.offline')
        }}</el-radio>
        <!-- 线下付款模式 -->
        <div class="offlinePaymentMode" v-if="detail.client_product_buy_channel.buy_channel == 2">
          <div class="name">
            {{ $t('message.offlinePaymentMode') }}
          </div>
          <!-- 全款支付 -->
          <el-radio v-model="detail.client_product_buy_channel.pay_type" :label="1"> {{
            $t('message.fullPayment')
          }}</el-radio>
          <!-- 分批付款 -->
          <p style="margin-top: 30px;">
            <el-radio v-model="detail.client_product_buy_channel.pay_type" :label="2"> {{
              $t('message.partialPayment')
            }}</el-radio>
          </p>
          <!-- 付款比例 -->
          <div class="part" v-if="detail.client_product_buy_channel.pay_type == 2">
            <div class="input">
              首付：
              <el-input v-model="detail.client_product_buy_channel.part_pay_first_rate" size="small" placeholder="首付款比例"
                @input="handleInput('part_pay_first_rate')">
                <template slot="append">%</template></el-input>
            </div>
            <div class="input">
              尾款：
              <el-input v-model="detail.client_product_buy_channel.part_pay_last_rate" size="small" placeholder="尾款比例"
                @input="handleInput('part_pay_last_rate')">
                <template slot="append">%</template></el-input>
            </div>
          </div>
        </div>
        <!-- 合同文件 -->
        <div class="offlinePaymentMode" v-if="detail.client_product_buy_channel.buy_channel == 2">
          <div class="name">
            {{ $t('message.contractDocuments') }}
            <el-upload action="https://jsonplaceholder.typicode.com/posts/" :http-request="httpFile"
              :show-file-list="false">
              <el-button type="primary">{{ $t('message.uploadFiles') }}</el-button>
            </el-upload>
          </div>
          <div class="file" v-if="detail.client_product_buy_channel.file">
            <i class="el-icon-document-checked">
            </i>
            <i class="el-icon-error"></i>
          </div>
          <p class="word-break" v-if="detail.client_product_buy_channel.file">
            <a :href="detail.client_product_buy_channel.file" target="_blank" rel="noopener noreferrer"
              class="a-link">{{
                detail.client_product_buy_channel.file_name }}</a>
          </p>
        </div>
      </div>
    </div>
    <!-- 联系人 -->
    <div class="item-body">
      <div class="name">{{ $t('message.contacts') }}</div>
      <!-- 业务联系人 -->
      <div class="row">
        <div class="label">{{ $t('message.businessContact') }}</div>
        <div class="value">
          <el-select v-model="detail.client_product_buy_channel.y_id" filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in authWorkGroupAdmin.y" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 采购联系人 -->
      <div class="row">
        <div class="label">{{ $t('message.purchasingContactPerson') }}</div>
        <div class="value">
          <el-select v-model="detail.client_product_buy_channel.g_id" filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in authWorkGroupAdmin.g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 工厂联系人 -->
      <div class="row">
        <div class="label">{{ $t('message.factoryContact') }}</div>
        <!-- 请输入联系人名字 -->
        <div class="value">
          <el-input :placeholder="$t('message.pleaseEnterTheNameOfTheContactPerson')"
            v-model="detail.client_product_buy_channel.factory_contact_name"></el-input>
        </div>
        <!--  联系人手机号-->
        <div class="value">
          <el-input :placeholder="$t('message.contactPhoneNumber')"
            v-model="detail.client_product_buy_channel.factory_contact_mobile"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['authWorkGroupAdmin'])
  },
  data() {
    return {
      detail: {
        client_product_buy_channel: {}
      },
    };
  },
  methods: {
    // 设置数据
    setData(sys_code_set) {
      let datas = {
        sys_code_set,
        ...this.detail.client_product_buy_channel
      }
      this.$api.productManagementApi.batchUpdatePurchase(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 设置
    setBuyChannel(column, value) {
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        column,
        value
      }

      this.$api.productManagementApi.setBuyChannel(datas)
    },
    // 上传文件
    async httpFile(file) {
      let data = await this.createClient(file)
      this.detail.client_product_buy_channel.file = data.data
      this.detail.client_product_buy_channel.file_name = file.file.name

    },
    // 是否输入的小数
    handleInput(type) {
      this.detail.client_product_buy_channel[type] = ("" + this.detail.client_product_buy_channel[type]) // 第一步：转成字符串
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
    },

  }
}
</script>
<style lang='scss' scoped>
.item-body {
  padding: 24px;
  border: 1px solid #dedede;
  border-radius: 10px;
  margin-bottom: 24px;

  .name {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
  }

  .row {
    margin-bottom: 50px;
    display: flex;
    padding-left: 12px;

    .label {
      width: 150px;
    }

    .value {
      margin-left: 30px;
    }
  }

  .offlinePaymentMode {
    min-width: 240px;
    padding: 24px;
    border: 1px solid #dedede;
    border-radius: 5px;
    margin-right: 50px;

    .file {
      position: relative;
      margin-right: 50px;
      width: 100px;

      .el-icon-document-checked {
        font-size: 100px;
      }

      .el-icon-error {
        font-size: 20px;
        color: #B4272B;
        position: absolute;
        top: -5px;
        right: -5px;
        cursor: pointer;
      }


    }

    p {
      width: 240px;
      margin-top: 12px;
      height: 40px;
      line-height: 20px;
      overflow: hidden;
      /* 隐藏超出部分 */
      display: -webkit-box;
      /* 使用Webkit的盒模型 */
      -webkit-line-clamp: 2;
      /* 限制最多显示两行 */
      -webkit-box-orient: vertical;
      /* 设置盒模型的方向为垂直 */

    }
  }

  .part {
    display: flex;
    justify-content: space-between;

    .input {
      margin-right: 50px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    /deep/.el-input {
      width: 120px;


    }

  }
}
</style>